import React from 'react'
import styled from 'styled-components'
import ReactGA from 'react-ga4'
import Button from '../../../components/buttons/buttons.component'
import BuyerData from './buyer-data.component'
import AcceptTerms from './accept-terms.component'
import ModalError from './modal-error/modal-error'
import PaymentData from './payment-data.component'
import OrderSummary from './order-summary.component'
import DiscountCoupon from './discount-coupon.component'
import RequestNumberComponent from './request-number.component'
import AffiliateCodeComponent from './affiliate-code.component'
import ReasonForTravelData from './reason-travel-data.component'
import PassengersData from './passengers-data.component'
import ticketSaleHelper from '../../../helpers/ticket-sale.helper'
import TicketSaleService from './../../../services/ticket-sale.service'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { breakpoints } from '../../../constants'
import { toastActions } from '../../../actions'
import { PassengerService } from '../../../services/passenger.service'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import * as CPFService from '../../../services/cpf.service'
import TripDiscountHelper from '../../../helpers/trip-discount.helper'
import { PAYMENT_METHODS, RoleConstants } from '../../../constants'
import { PRIMARY_COLOR } from '../../../styles/colors.style'
import { AdminTicketService } from '../../../services/admin-ticket.service'
import { content } from '../../../../config'

const { GOOGLE_CONVERTION } = content

const style = {
	container: {
		marginBottom: '2rem',
		lineHeight: '2em',
		borderBottom: `1px solid ${PRIMARY_COLOR}`,
		display: 'flex',
		boxPack: 'justify',
		justifyContent: 'space-between',
		boxAlign: 'center',
		alignItems: 'center',
		paddingBottom: '1rem',
	},
	title: {
		color: PRIMARY_COLOR,
		fontSize: '3.2rem',
		marginTop: '1rem',
	},
}

const InitialState = {
	isOpen: false,
	onClose: false,
	buyerValues: {},
	muvicardCpf: '',
	paymentValues: {},
	passengersValues: [],
	acceptTermsValues: {},
	htmlDebitContent: '',
	muvicardOneClick: false,
	buyerDataIsValid: false,
	modalErrorIsOpen: false,
	modalErrorMessage: '',
	acceptTermsIsValid: false,
	paymentDataIsValid: false,
	passengersDataIsValid: false,
	shouldRenderModalDebt: false,
	purchaseButtonDisabled: false,
	cpf: null,
	cpfChecked: false,
	couponPaymentMethod: 0,
	travelReasonValues: null,
	otherTravelReasonValues: null,
}

class PaymentStepComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			...InitialState,
			discountParameters: {},
			muvicardDiscountParameters: {},
		}

		this.forms = {}
		this.onClose = onClose.bind(this)
		this.onSubmitBuyer = onSubmitBuyer.bind(this)
		this.onSubmitPayment = onSubmitPayment.bind(this)
		this.finalizePurchase = finalizePurchase.bind(this)
		this.handleCloseModal = handleCloseModal.bind(this)
		this.onSubmitPassengers = onSubmitPassengers.bind(this)
		this.validateAndProceed = validateAndProceed.bind(this)
		this.onSubmitAcceptTerms = onSubmitAcceptTerms.bind(this)
		this.onSubmitReasonTravel = onSubmitReasonTravel.bind(this)
		this.validatePassengersDuplicatedData =
			validatePassengersDuplicatedData.bind(this)
		this.resetState = resetState.bind(this)
	}

	async componentDidMount() {
		this.props.hideLoading()

		const { success, data } = await TicketSaleService.getDiscountParameters()

		if (success) {
			this.setState({ discountParameters: data })
		}
	}

	async componentDidUpdate(prevProps) {
		if (this.props.muvicardCpf !== prevProps.muvicardCpf) {
			let params = { cpf: this.props.muvicardCpf }
			await TicketSaleService.getMuvicardDiscountParameters(params).then(
				({ success, data }) => {
					if (success) {
						this.setState({ muvicardDiscountParameters: data })
					}
				}
			)
		}
	}

	render() {
		const {
			user,
			previousStep,
			isPaymentStep,
			routeClassType,
			discountPercentage,
			backToPreviousStep,
			serviceChargeSelected,
			selectedBusSeatsGoing,
			selectedBusSeatsReturn,
			conexao,
			rebookingTicketValue,
			discountLabel,
			paymentMethod,
			discountValue,
			setDiscountLabel,
			setDiscountValue,
			discountCouponCode,
			setDiscountPercent,
			calculatedValues,
		} = this.props

		if (!this.props.isEtapaPagamento) {
			return <div />
		}

		const { ticketsGoing, ticketsReturn, totalDiscount, totalOrderValue } =
			calculatedValues

		const originGoing = ticketsGoing[0].originCity
		const destinationGoing =
			ticketsGoing[ticketsGoing.length - 1].destinationCity

		let originReturn = ''
		let destinationReturn = ''

		if (ticketsReturn.length) {
			originReturn = ticketsReturn[0].originCity
			destinationReturn =
				ticketsReturn[ticketsReturn.length - 1].destinationCity
		}

		const isPublicBody = user && user.hasPublicBody
		const isRequester = user && user.isRequester

		const IsElegibleForBenefit = user && user.isEligibleForBenefit

		let busCompany = serviceChargeSelected
			? serviceChargeSelected.busCompany
			: ''

		const isInterstate = !!routeClassType.isInterstate

		const notOnlyPoints = totalOrderValue > 0

		let familyPercentDiscount = 0
		let muvicardPercentDiscount = 0

		let hasPromotionalSeat =
			ticketsGoing.find((ticketGoing) => ticketGoing.isPromotionalSeat) ||
			ticketsReturn.find((ticketReturn) => ticketReturn.isPromotionalSeat)

		// Desconto cupom
		let hasCouponDiscount = discountPercentage > 0 && !hasPromotionalSeat

		// Parametrização do Desconto família e Muvicard
		const { discountParameters, muvicardDiscountParameters } = this.state

		// Desconto Família - condições
		let conditionToApplyFamilyDiscount =
			TripDiscountHelper.getFamilyDiscount(discountParameters)

		// Desconto Família
		let hasFamilyDiscount = false

		if (discountParameters.discountFamily) {
			hasFamilyDiscount =
				(selectedBusSeatsGoing.length >= conditionToApplyFamilyDiscount ||
					selectedBusSeatsReturn.length >=
						conditionToApplyFamilyDiscount) &&
				discountPercentage <
					discountParameters.discountFamily.percentDiscount &&
				discountParameters.discountFamily.isActive &&
				totalPoints === 0 &&
				user !== null &&
				!hasPromotionalSeat

			if (hasFamilyDiscount)
				familyPercentDiscount =
					discountParameters.discountFamily.percentDiscount
		}

		// Desconto do cartão Muvicard
		let hasMuvicardDiscount = false

		if (
			muvicardDiscountParameters.muvicardDiscount &&
			paymentMethod === PAYMENT_METHODS.MUVICARD &&
			!hasPromotionalSeat
		) {
			let muvicardDiscountObject =
				muvicardDiscountParameters.muvicardDiscount

			hasMuvicardDiscount =
				muvicardDiscountObject.isActive && muvicardDiscountObject.isValid

			muvicardPercentDiscount = hasMuvicardDiscount
				? muvicardDiscountObject.percentDiscount
				: 0
		}

		let newDiscountLabel = ''

		// Muvicard
		if (
			hasMuvicardDiscount &&
			muvicardPercentDiscount > discountPercentage &&
			muvicardPercentDiscount > familyPercentDiscount
		) {
			newDiscountLabel = 'Desconto Muvicard'

			setDiscountPercent(discountPercentage)
			setDiscountLabel(discountLabel)
			setDiscountValue(totalDiscount)
		}

		if (discountLabel == 'Desconto Muvicard' && !hasMuvicardDiscount) {
			setDiscountPercent(0)
			setDiscountLabel('')
			setDiscountValue(0)
		}

		if (discountLabel == 'Cupom de desconto' && discountCouponCode == '') {
			setDiscountPercent(0)
			setDiscountLabel('')
			setDiscountValue(0)
		}

		// Cupom
		if (
			hasCouponDiscount &&
			discountPercentage >= muvicardPercentDiscount &&
			discountPercentage >= familyPercentDiscount
		) {
			newDiscountLabel = 'Cupom de desconto'

			setDiscountPercent(muvicardPercentDiscount)
			setDiscountLabel(discountLabel)
			setDiscountValue(totalDiscount)
		}

		// Família
		if (
			hasFamilyDiscount &&
			familyPercentDiscount > discountPercentage &&
			familyPercentDiscount > muvicardPercentDiscount
		) {
			newDiscountLabel = 'Desconto família'

			setDiscountPercent(familyPercentDiscount)
			setDiscountLabel(discountLabel)
			setDiscountValue(totalDiscount)
		}

		if (newDiscountLabel === '' && discountValue > 0) {
			setDiscountPercent(0)
			setDiscountValue(0)
			setDiscountLabel(null)
		}

		let isReverse = false

		let totalValue = totalOrderValue

		if (rebookingTicketValue >= totalValue) {
			totalValue = rebookingTicketValue - totalValue
			isReverse = true
		} else {
			totalValue = totalValue - rebookingTicketValue
		}

		const showPaymentSection =
			!isReverse && (totalValue > 0 || totalValue > 0)

		const isPromotionCoupon = this.props.discountCoupon.isPromotion

		return (
			<React.Fragment>
				<div style={style.container}>
					<div style={style.title}>{`Passageiro${
						ticketsGoing.length > 1 ? 's' : ''
					}`}</div>
				</div>
				<PassengersData
					onSubmit={this.onSubmitPassengers}
					getFormsRefs={(getForms) => (this.getPassengersForms = getForms)}
				/>
				{user == null ? (
					<React.Fragment>
						<div style={style.container}>
							<div style={style.title}>{`Dados do comprador`}</div>
						</div>
						<BuyerData
							onSubmit={this.onSubmitBuyer}
							getFormRef={(form) => (this.forms.buyerDataForm = form)}
							cpfChecked={() => {
								const cpfValid = CPFService.validate(this.state.cpf)
								this.setState({ cpfChecked: cpfValid })

								this.forms.buyerDataForm.submitForm()
							}}
							onChangeCpf={(cpf) => {
								this.setState({
									cpf: cpf,
									buyerDataIsValid: false,
									cpfChecked: false,
								})

								if (!isPromotionCoupon) {
									this.props.resetDiscountCoupon()
								}
							}}
						/>
					</React.Fragment>
				) : null}
				{showPaymentSection ? (
					<React.Fragment>
						<div style={style.container}>
							<div style={style.title}>{`Forma de pagamento`}</div>
						</div>
						<PaymentData
							handleCompleteCpf={(cpf) => {
								this.setState({ muvicardCpf: cpf })
							}}
							totalValue={totalValue}
							busCompany={busCompany}
							onSubmit={this.onSubmitPayment}
							getFormRef={(form) => (this.forms.paymentDataForm = form)}
						/>
					</React.Fragment>
				) : null}

				{isRequester && (
					<React.Fragment>
						<div style={style.container}>
							<div style={style.title}>{`Requisição`}</div>
						</div>

						<RequestNumberComponent />
					</React.Fragment>
				)}

				{(!isPublicBody && notOnlyPoints && !IsElegibleForBenefit) ||
				isRequester ? (
					<React.Fragment>
						<div style={style.container}>
							<div
								style={style.title}>{`Possui cupom de desconto?`}</div>
						</div>

						<DiscountCoupon
							user={user}
							cpf={this.state.cpf}
							isCpfChecked={this.state.cpfChecked}
							busCompany={busCompany}
							boardingDate={this.props.tripDateGoing}
							isPaymentStep={isPaymentStep}
							busSeatsLength={selectedBusSeatsGoing.length}
							hasReturn={this.props.groupReturn ? true : false}
							originGoing={originGoing}
							originReturn={originReturn}
							destinationGoing={destinationGoing}
							destinationReturn={destinationReturn}
							busClass={this.props.tripGoing.busClass}
						/>
					</React.Fragment>
				) : null}

				<React.Fragment>
					<div style={style.container}>
						<div style={style.title}>{`Afiliado`}</div>
					</div>

					<AffiliateCodeComponent />
				</React.Fragment>
				<React.Fragment>
					<div style={style.container}>
						<div style={style.title}>{`Motivo de Viagem`}</div>
					</div>
					<ReasonForTravelData
						onSubmit={this.onSubmitReasonTravel}
						getFormRef={(ref) => (this.forms.reasonForTravelForm = ref)}
					/>
				</React.Fragment>

				<div style={style.container}>
					<div style={style.title}>{`Resumo do pedido`}</div>
				</div>

				<OrderSummary isReverse={isReverse} totalValue={totalValue} />

				<AcceptTerms
					onSubmit={this.onSubmitAcceptTerms}
					getFormRef={(ref) => (this.forms.acceptTermsForm = ref)}
				/>
				<StyledButtonContainer>
					{/* Remover quando for conexão */}
					{!conexao.ehConexaoIda ? (
						<Button
							secondary
							type="button"
							onClick={() => (backToPreviousStep(), previousStep())}>
							Voltar
						</Button>
					) : null}

					<Button
						primary
						type="button"
						className="finish-purchase"
						disabled={this.state.purchaseButtonDisabled}
						onClick={() =>
							this.validateAndProceed(showPaymentSection, totalValue)
						}>
						Finalizar compra
					</Button>
				</StyledButtonContainer>
				<ModalError
					isOpen={this.state.modalErrorIsOpen}
					message={this.state.modalErrorMessage}
					onClose={this.handleCloseModal}
					isInterstateRedirect={
						isInterstate
							? () => (backToPreviousStep(), previousStep())
							: null
					}
				/>
			</React.Fragment>
		)
	}
}

function onClose() {
	this.setState({ isOpen: false })
	this.refs.form.resetForm()
}

function onSubmitBuyer(buyerValues) {
	this.setState({ buyerValues, buyerDataIsValid: true })
}

function onSubmitPayment(paymentValues) {
	this.setState({ paymentValues, paymentDataIsValid: true })
}

function onSubmitAcceptTerms(acceptTermsValues) {
	this.setState({ acceptTermsValues, acceptTermsIsValid: true })
}

function onSubmitReasonTravel(reasonTravelValues) {
	this.setState({
		travelReasonValues: reasonTravelValues.travelReason,
		otherTravelReasonValues: reasonTravelValues.otherTravelReason,
	})
}

function handleCloseModal() {
	this.setState({ modalErrorIsOpen: false, modalErrorMessage: '' })
	this.props.history.push('/')
}
function onSubmitPassengers(passengerValues) {
	const { passengersValues } = this.state
	passengersValues.push(passengerValues)

	this.props.user !== null
		? PassengerService.addPassenger(passengerValues)
		: null

	this.setState({ passengersValues })
	if (passengersValues.length == this.props.numberOfPassengers) {
		this.setState({ passengersDataIsValid: true })
	}
}

function validatePassengersDuplicatedData() {
	const { passengersValues } = this.state
	for (const passenger of passengersValues) {
		const isDuplicatedData =
			passengersValues.filter(
				({ documenttype, documentnumber }) =>
					passenger.documenttype == documenttype &&
					passenger.documentnumber == documentnumber
			).length > 1
		if (isDuplicatedData) {
			return false
		}
	}
	return true
}

async function validateAndProceed(showPaymentSection, totalValue) {
	if (this.state.purchaseButtonDisabled) {
		return
	}

	this.setState({
		...InitialState,
		passengersValues: [],
	})

	const { user } = this.props

	if (!user) {
		await this.forms.buyerDataForm.submitForm()
	}

	if (showPaymentSection) {
		await this.forms.paymentDataForm.submitForm()
	} else {
		this.setState({ paymentDataIsValid: true })
	}

	const passengersForms = this.getPassengersForms()

	for (const passengerForm of passengersForms) {
		passengerForm.submitForm()
	}

	await this.forms.reasonForTravelForm.submitForm()

	// Validando o "Accept Terms"
	await this.forms.acceptTermsForm.submitForm()

	const noDuplicatedData = this.validatePassengersDuplicatedData()

	const {
		buyerDataIsValid,
		acceptTermsIsValid,
		paymentDataIsValid,
		passengersDataIsValid,
	} = this.state

	const canProceed =
		noDuplicatedData &&
		acceptTermsIsValid && // Verifica se os termos foram aceitos
		paymentDataIsValid &&
		passengersDataIsValid &&
		(buyerDataIsValid || user)

	if (canProceed) {
		this.setState({ purchaseButtonDisabled: true })

		await this.finalizePurchase(totalValue)
	} else {
		this.setState({
			purchaseButtonDisabled: false,
		})

		const message = getWarningMessage({
			buyerDataIsValid,
			paymentDataIsValid,
			passengersDataIsValid,
			isAuthenticated: !!user,
			noDuplicatedData,
			acceptTermsIsValid,
		})

		if (message) this.props.toastWarning({ message })
	}
}

function getWarningMessage({
	buyerDataIsValid,
	paymentDataIsValid,
	passengersDataIsValid,
	isAuthenticated,
	noDuplicatedData,
	acceptTermsIsValid, // Adiciona a verificação de AcceptTerms
}) {
	if (!acceptTermsIsValid)
		return 'Você precisa aceitar os termos para continuar'
	else if (!passengersDataIsValid) return 'Verifique os dados dos passageiros'
	else if (!noDuplicatedData)
		return 'O número do documento deve ser único para cada passageiro'
	else if (!(isAuthenticated || buyerDataIsValid))
		return 'Verifique os dados do comprador'
	else if (!paymentDataIsValid) return 'Verifique os dados de pagamento'
}

function resetState(errorMsg = '') {
	this.setState({
		...InitialState,
		modalErrorMessage: errorMsg,
		modalErrorIsOpen: !!errorMsg,
	})
}

async function finalizePurchase(totalValue) {
	const { hideLoading, showLoading, user, interestRate } = this.props

	let passagerBirthDay = null

	this.state.passengersValues.map((passenger) => {
		if (passenger.loggedpassenger) {
			passagerBirthDay = passenger.birthdate
		}
	})

	const statesPrepared = this.state

	if (passagerBirthDay && !user.birthday) {
		statesPrepared.buyerValues = {
			...statesPrepared.buyerValues,
			birthdate: passagerBirthDay,
		}
	}
	const params = ticketSaleHelper.getParams(statesPrepared, this.props)
	showLoading()

	try {
		const allowedAdmins = [
			RoleConstants.Employee,
			RoleConstants.Admin,
			RoleConstants.Sac,
			RoleConstants.SacUp,
		]

		const userHasAdminRole =
			user && Array.isArray(user.roles)
				? user.roles.some((role) => allowedAdmins.includes(role))
				: false

		const params = ticketSaleHelper.getParams(statesPrepared, this.props)

		let response
		if (params.purchaseForCustomerId && userHasAdminRole) {
			response = await AdminTicketService.finalizePurchase(params)
		} else {
			response = await TicketSaleService.finalizePurchase(params)
		}

		const { success, errors, data } = response

		this.props.setCalculatedValues({
			...this.props.calculatedValues,
			totalOrderValue: totalValue,
			totalInterest: interestRate,
		})

		hideLoading()

		if (!success) throw new Error(errors[0])

		const { setConfirmedPurchaseData, nextStep, goToNextStep } = this.props

		setConfirmedPurchaseData(data, this.state)
		nextStep()
		goToNextStep()

		ReactGA.event('purchase', {
			transaction_id: data.orderNumber,
			currency: 'BRL',
			value: data.orderValue,
			items: [
				{
					item_name: 'Compra de passagem',
					item_id: '--',
					price: data.orderValue,
					quantity: 1,
					item_category: 'Compra de passagem',
					currency: 'BRL',
					points:
						(this.props.tripPriceGoing.points +
							this.props.tripPriceReturn.points) *
						this.props.numberOfPassengers,
				},
			],
		})

		window.fbq.push([
			'track',
			'Purchase',
			{ value: totalValue, currency: 'BRL' },
		])

		ReactGA.event('purchase', {
			currency: 'BRL',
			value: data.orderValue,
			transaction_id: data.orderNumber,
		})

		window.gtag('event', 'conversion', {
			send_to: GOOGLE_CONVERTION,
			value: data.orderValue,
			currency: 'BRL',
			transaction_id: data.orderNumber,
		})

		// if params have object debitcard
		if (params.debitCard.length > 0) {
			debitCardModal(data)
		}
	} catch (errorMsg) {
		hideLoading()

		let msg = `Parece que algo deu errado e a compra não foi finalizada :( 
			<br/><br/> Tente a compra novamente em alguns minutos. Se você estava realizando compra com cartão de crédito e ocorreu algum erro de processamento, não se preocupe, a compra não será cobrada.
			<br/><br/>Em caso de dúvida sobre a compra que apresentou erro no processamento envie e-mail para <a href="mailto:faleconosco@muviflex.com.br?Subject=Fale conosco - Muviflex site">faleconosco@muviflex.com.br</a>
		`

		this.resetState(!!errorMsg ? errorMsg : msg)
	} finally {
		this.props.resetRebookingData()
	}
}

const debitCardModal = (data) => {
	if (data) {
		const { redirect_url, MD, PaReq, TermUrl } = data

		const obj = {
			MD,
			PaReq,
			TermUrl,
			redirectUrl: redirect_url,
		}

		TicketSaleService.sendGetNetDebitCard(obj)
			.then((response) => {
				if (response.success) {
					this.setState({
						htmlDebitContent: response.data,
						shouldRenderModalDebt: true,
						isOpen: true,
					})
					hideLoading()
				}
			})
			.catch(console.error)
	}
}

const StyledButtonContainer = styled.div`
	display: flex;
	flex-direction: column-reverse;
	justify-content: flex-end;
	margin-top: 40px;
	margin-bottom: 60px;

	.finish-purchase {
		margin-bottom: 15px;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;

		.finish-purchase {
			margin-bottom: initial;
			margin-left: 15px;
		}
	}
`

const mapStateToProps = (store) => ({
	user: store.user,
	requestNumber: store.ticketSale.requestNumber,
	affiliateCode: store.ticketSale.affiliateCode,
	travelReason: store.ticketSale.travelReason,
	otherTravelReason: store.ticketSale.otherTravelReason,
	deviceId: store.antiFraud.sessionID,
	groupGoing: store.ticketSale.groupGoing,
	raceDateGoing: store.ticketSale.raceDateGoing,
	raceDateReturn: store.ticketSale.raceDateReturn,
	priceGoing: store.ticketSale.priceGoing,
	priceReturn: store.ticketSale.priceReturn,
	groupReturn: store.ticketSale.groupReturn,
	originState: store.ticketSale.originState,
	serviceGoing: store.ticketSale.serviceGoing,
	originPortal: store.ticketSale.originPortal,
	serviceReturn: store.ticketSale.serviceReturn,
	tripDateGoing: store.ticketSale.tripDateGoing,
	paymentMethod: store.ticketSale.paymentMethod,
	discountCoupon: store.ticketSale.discountCoupon,
	extraDataGoing: store.ticketSale.extraDataGoing,
	isUpgradeGoing: store.ticketSale.isUpgradeGoing,
	originIbgeCode: store.ticketSale.originIbgeCode,
	tripDateReturn: store.ticketSale.tripDateReturn,
	extraDataReturn: store.ticketSale.extraDataReturn,
	isUpgradeReturn: store.ticketSale.isUpgradeReturn,
	destinationState: store.ticketSale.destinationState,
	busSeatsGoing: store.busSeatSelection.busSeatsGoing,
	tripPriceGoing: store.ticketSale.selectedPriceGoing,
	originLocalityId: store.ticketSale.originLocalityId,
	tripPriceReturn: store.ticketSale.selectedPriceReturn,
	totalSeatsGoing: store.busSeatSelection.totalSeatsGoing,
	destinationIbgeCode: store.ticketSale.destinationIbgeCode,
	destinationLocalityId: store.ticketSale.destinationLocalityId,
	discountPercentage: store.ticketSale.discountCoupon.discountPercentage,
	rebookingTicketValue: store.ticketSale.rebookingData.rebookingValue,
	tripGoing: TicketSaleSelectors.getTripGoing(store),
	tripReturn: TicketSaleSelectors.getTripReturn(store),
	isPaymentStep: TicketSaleSelectors.isPaymentStep(store),
	buyerAddress: TicketSaleSelectors.getBuyerAddress(store),
	routeClassType: TicketSaleSelectors.getRouteClassType(store),
	serviceCharge: TicketSaleSelectors.getServiceChargeValue(store),
	serviceChargeSelected: TicketSaleSelectors.getServiceChargeSelector(store),
	isEtapaPagamento: TicketSaleSelectors.getEtapaPagamento(store),
	numberOfPassengers: BusSeatSelectionSelectors.getNumberOfPassengers(
		store.busSeatSelection
	),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
	selectedPoltonasVolta: BusSeatSelectionSelectors.getSelectedViagemVolta(
		store.busSeatSelection
	),
	conexao: store.conexao,
	rebookingData: store.ticketSale.rebookingData,
	discountLabel: store.ticketSale.discountLabel,
	discountValue: store.ticketSale.discountValue,
	discountCouponCode: store.ticketSale.discountCoupon.code,
	discountPercentage: store.ticketSale.discountCoupon.discountPercentage,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	interestRate: CreditCardPurchaseSelectors.getInterestRate(
		store.creditCardPurchase
	),
})

const mapDispatchToProps = {
	toastWarning: toastActions.warning,
	hideLoading: SiteCreators.hideLoading,
	showLoading: SiteCreators.showLoading,
	goToNextStep: TicketSaleCreators.goToNextStep,
	backToPreviousStep: TicketSaleCreators.backToPreviousStep,
	setConfirmedPurchaseData: TicketSaleCreators.setConfirmedPurchaseData,
	resetDiscountCoupon: TicketSaleCreators.resetDiscountCoupon,
	resetRebookingData: TicketSaleCreators.resetRebookingData,
	setDiscountValue: TicketSaleCreators.discountValue,
	setDiscountLabel: TicketSaleCreators.discountLabel,
	setDiscountPercent: TicketSaleCreators.discountPercent,
	setTotalPointsOnTicketSale: TicketSaleCreators.totalPointsOnTicketSale,
	setCalculatedValues: TicketSaleCreators.setCalculatedValues,
}

const PaymentStep = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PaymentStepComponent)
)

export default PaymentStep
